export default __webpack_public_path__ + "static/qingcloud-office-697b52bd830a47597db0607ed9971ffa.jpeg";